import { withInstall } from '@lit-element/utils'
import Countdown from './src/countdown.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const ltCountdown: SFCWithInstall<typeof Countdown> =
  withInstall(Countdown)
export default ltCountdown

export * from './src/countdown'
